export type LocationEntry = {
  country?: string;
  state?: string;
  displayName: string;
};

export interface LocationState {
  name: string;
  slug: string;
  value: string;
  jobCount: number;
}

export interface LocationCountry {
  name: string;
  slug: string;
  value: string;
  jobCount: number;
  states: LocationState[];
}

export interface LocationsResponse {
  countries: LocationCountry[];
}

/**
 * Find a location entry by slug from the API response.
 * Returns country/state filter values and display name, or null if not found.
 */
export function findLocationBySlug(
  slug: string,
  locations: LocationsResponse,
): LocationEntry | null {
  if (!locations?.countries) return null;
  for (const country of locations.countries) {
    if (country.slug === slug) {
      return { country: country.value, displayName: country.name };
    }
    for (const state of country.states) {
      if (state.slug === slug) {
        return { state: state.value, displayName: state.name };
      }
    }
  }
  return null;
}
